import React from 'react';
import './style.less';

export const SearchBox = ({children}) => (
    <div className="search__box-container">
        <div className="context">
            <div className="search__box">
                {children}
            </div>
        </div>
    </div>
);
